import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NavigationNode } from '../../mb-navigation.service'
import { MbProductByOriginalCodeService } from '../../../../product/services/mb-product-by-original-code.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { WindowRef } from '@spartacus/core'
import { CmsLinkType } from '../../../enums/cms-link-type'

@Component({
  selector: 'mb-category-navigation-link',
  templateUrl: './mb-category-navigation-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationLinkComponent implements OnInit {

  @Output() closeNavigation = new EventEmitter()

  @Input() route: any
  @Input() category: any
  @Input() subCategory: any
  @Input() index: any
  @Input() subcategoryIndex: any
  @Input() dataFilter: string | undefined
  @Input() dataColor: string | undefined
  @Input() dataEventAction: string | undefined
  @Input() text: string | undefined

  show$: Observable<boolean> | undefined

  constructor (private productService: MbProductByOriginalCodeService,
               protected winRef: WindowRef) {

  }

  ngOnInit (): void {
    if (!this.route?.productId?.length) {
      this.show$ = of(true)
      return
    }
    try {
      this.show$ = this.productService.getProductByOriginalCode(this.route.productId).pipe(map(p => !!p))
    } catch (e) {
      this.show$ = of(false)
    }
  }

  getCategoryColor (category: NavigationNode): string {
    return category?.color || 'corporate-orange'
  }

  onClose (event: Event): void {
    this.closeNavigation.emit(event)
  }

  protected readonly cmsLinkType = CmsLinkType
}
